export default __webpack_public_path__ + "static/media/office1-after2-1440w.a3ac741f.avif";